// extracted by mini-css-extract-plugin
export default {"box":"SummaryCheckField_box__-jF1u","summary":"SummaryCheckField_summary__fRHle"};